import { useLocalStorage } from '@vueuse/core'

export const useTemplateStore = defineStore({
    id: 'useTemplateStore',
    state: () => ({
        mainSidebar: useLocalStorage('lynx/CT/mainSidebar', 1),
        leftBarActive: useLocalStorage('lynx/CT/leftBarActive', false),
        rightBarActive: useLocalStorage('lynx/CT/rightBarActive', false),
        leftBar: useLocalStorage('lynx/CT/leftBar', 1),
        rightBar: useLocalStorage('lynx/CT/rightBar', 1),
        leftBarWidth: '13rem',
        rightBarWidth: '13rem',
        toolbar: false,
        grid: 0,
        leftbarAvailable: false,
        rightbarAvailable: false,
    }),
    getters: {
        mainSidebarValue: state => state.mainSidebar,
        leftBarValue: state => state.leftBar,
        rightBarValue: state => state.rightBar,
        leftBarWidthValue: state => state.leftBarWidth,
        rightBarWidthValue: state => state.rightBarWidth,
        leftBarActiveValue: state => state.leftBarActive,
        rightBarActiveValue: state => state.rightBarActive,
        toolbarValue: state => state.toolbar,
        gridValue: state => state.grid,
        leftbarAvailableValue: state => state.leftbarAvailable,
        rightbarAvailableValue: state => state.rightbarAvailable,
    },
    actions: {
        // uncheckQty() {
        //   console.log("xaction", this.new.qty_ok);
        //   this.new.qty_ok = false;
        //   console.log("action", this.new.qty_ok);
        // },
    },
    hydrate(state, initialState) {
        // if (process.client) {
        // }
    },
})
